import Image from 'next/legacy/image';
import { Card } from '@yoweb/ui/components/containers';
import { Title } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { CaretRightIcon } from '@yoweb/ui/components/Icon/CaretRightIcon';
import { CardButtonWrapper } from '@poplar/components/TaskTemplate/CardButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CategoryCard = function CategoryCard(_ref) {
  var card = _ref.card,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(CardButtonWrapper, {
    onClick: onClick,
    as: "button",
    children: /*#__PURE__*/_jsxs(Card, {
      display: "flex",
      flexDirection: "row",
      height: 72,
      gap: "small4",
      p: "normal1",
      radii: "small",
      justifyContent: "space-between",
      alignItems: "center",
      "data-testid": "category-card",
      children: [/*#__PURE__*/_jsxs(Box, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "small4",
        children: [/*#__PURE__*/_jsx(Box, {
          p: "small4",
          backgroundColor: "sandLight",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          radii: "full",
          children: /*#__PURE__*/_jsx(Image, {
            src: card.iconImageUrl,
            width: 24,
            height: 24
          })
        }), /*#__PURE__*/_jsx(Title, {
          size: "xs",
          lineHeight: "normal",
          children: card.name
        })]
      }), /*#__PURE__*/_jsx(Box, {
        display: "flex",
        children: /*#__PURE__*/_jsx(CaretRightIcon, {
          size: "24"
        })
      })]
    })
  });
};